module.exports = __webpack_public_path__ + "static/img/logo.2758af5d.svg";